import React, { memo } from 'react';
import Table from 'lib/components/table.jsx';
import Panel from './panel.jsx';
import { Spinner } from 'lib/components/loading.jsx';
import { LoadingIndicator } from 'lib/components/loading.jsx';
import { cn, addClasses } from 'lib/helpers/class.js';
import { DocumentMagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid';

const SearchResults = function (props) {
    const { data, isSuccess, isLoading, isRefetching, isError, ...tableProps } = props;
    const noEntries = !data || data?.pages.at(0)?.results?.length === 0;
    const hasEntries = !noEntries;

    console.log('noEntries: ', noEntries);

    return (
        <React.Fragment>
            {noEntries && isLoading && (
                <Panel className={addClasses('mx-4')}>
                    <Spinner className={addClasses('mx-auto')} />
                </Panel>
            )}
            {hasEntries && (
                <div className="relative grid mb-4">
                    <Table.Full
                        data={data}
                        spacing="compact"
                        className={addClasses('area-span-full')}
                        accessor={(data) => data.results}
                        {...tableProps}
                        isFetchingNextPage={isRefetching}
                        paginated
                    />
                    {/* <LoadingIndicator
                        className={addClasses(
                            cn(
                                isRefetching ? 'opacity-1' : 'opacity-0',
                                'area-span-full pointer-events-none sticky inset-y-0 my-4 mr-2 self-end justify-self-end rounded-full bg-white/80 p-1 transition-opacity'
                            )
                        )}
                        isLoading={isRefetching}
                    /> */}
                </div>
            )}
            {(isSuccess || isError) && noEntries && (
                <Panel>
                    <div className="flex items-center justify-center gap-2">
                        {isSuccess && <DocumentMagnifyingGlassIcon className="icon text-neutral-600" />}
                        {isError && <XMarkIcon className="icon text-neutral-600" />}
                        <p className="text-center text-sm text-neutral-800">
                            {/* {isSuccess && noEntries && _t.global.noResults()} */}
                            {isError && _t.global.searchError()}
                        </p>
                        {isRefetching &&
                            <Spinner className={addClasses('mx-auto')} />
                        }
                    </div>
                </Panel>
            )}
        </React.Fragment>
    );
};

export default SearchResults;
